import HttpStatusCode from 'http-status-codes'

const addAuthHeader = (headers, token) => {
  headers.Authorization = `Bearer ${token}`
  return headers
}

const parseResponse = (res) => {
  if (res.data) {
    return res.data
  }
  return null
}
const parseErrorResponse = (e) => {
  const err = e
  /* if (e instanceof Error) {
    err = JSON.parse(JSON.stringify(e))
  } */
  console.log('err', err.response)
  if (err.status > 500) {
    const errorMessage = `Error: ${err.status} ${HttpStatusCode.getStatusText(err.status)}`
    return errorMessage
  }
  if (err.error) {
    if (err.error.data) {
      return err.error.data
    }
  }
  if (err.data) {
    return err.data
  }
  if (err.response) {
    if (err.response.data) {
      // check for invalid token
      if (err.response.data.message &&
        (err.response.data.message === 'Token not found' ||
          err.response.data.message === 'Invalid Token'
        )) {
        /* store.dispatch('auth/logout')
          .finally(() => {
            window.location.replace(window.location.origin)
          }); */
      }
      const data = err.response.data
      console.log('error data', data)
      if (data.error) {
        // check empty data object
        if (data.error.data) {
          if (Object.keys(data.error.data).length > 0 ||
            typeof data.error.data === 'string') {
            return data.error.data
          }
        }
        return data.error
      }
      return data
    }
  }
  return err
}

export default (context, cancellationSource = null) => {
  const http = context.$axios
  const source = cancellationSource
  http.defaults.timeout = process.env.API_REQUEST_TIMEOUT || 300000

  return {
    login (email, password) {
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users/authenticate`, {
          username: email,
          password
        }).then((res) => {
          resolve(parseResponse(res))
        }).catch((e) => {
          reject(parseErrorResponse(e))
        })
      })
    },
    adminLogin (email, password, isAdmin) {
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users/admin-authenticate`, {
          username: email,
          password
        }).then((res) => {
          resolve(parseResponse(res))
        }).catch((e) => {
          reject(parseErrorResponse(e))
        })
      })
    },
    register (payload) {
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users`, payload)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    verifyUser (token) {
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users/verify`, {
          token
        })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    forgotPassword (payload) {
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users/forgot-password`, payload)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    resetPassword (payload) {
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users/reset-password`, payload)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    sendVerificationCode (payload) {
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users/send-verification-code`, payload)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    confirmVerificationCode (payload) {
      const userIdentity = context.store.getters['auth/userIdentity']
      let headers = {}
      if (userIdentity) {
        headers = addAuthHeader(headers, userIdentity.access_token)
      }
      return new Promise((resolve, reject) => {
        http.post(`/api/v1/users/confirm-verification-code`, payload, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getMyInfo () {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.get(`/api/v1/users/me`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    generateMyQR () {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.post(`/api/v1/users/access`, null, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    searchAvailableRooms ({ timeSlots, roomType, capacity }) {
      return new Promise((resolve, reject) => {
        const query = {
          time_slots: timeSlots,
          room_type: roomType,
          capacity
        }
        const params = Object.keys(query)
          .map(key => [key, query[key]].join('='))
          .join('&')

        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.get(`/api/v1/booking/search?${params}`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    listRoom (zone) {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/booking/rooms?zone=${zone}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    bookRoom ({ roomId, fromTime, toTime, roomSetupId }) {
      return new Promise((resolve, reject) => {
        const payload = {
          room_id: roomId,
          from_time: fromTime,
          to_time: toTime,
          room_setup_id: roomSetupId,
          notes: ''
        }
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.post('/api/v1/booking', payload, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getMyBookingStatus () {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.get(`/api/v1/booking/status`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getMyBookingQuota () {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.get(`/api/v1/booking/quota`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getMyBookings (query) {
      return new Promise((resolve, reject) => {
        /* const query = {
          from_time: fromTime,
          to_time: toTime
        } */
        const params = Object.keys(query)
          .map(key => [key, query[key]].join('='))
          .join('&')
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.get(`/api/v1/booking?${params}`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getBooking (bookingId) {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.get(`/api/v1/booking/${bookingId}`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    cancelBooking (bookingId) {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.delete(`/api/v1/booking/${bookingId}`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getEducationInstitutes () {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/data/education-institutes`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    searchUsers (query) {
      return new Promise((resolve, reject) => {
        const q = Object.keys(query).map((key) => {
          return `${key}=${query[key]}`
        }).join('&')
        http.get(`/api/v1/users/search?${q}`, {
          cancelToken: source ? source.token : null
        })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            if (http.isCancel(e)) {
              resolve([])
            } else {
              reject(parseErrorResponse(e))
            }
          })
      })
    },
    adminVerifyUser (payload) {
      return new Promise((resolve, reject) => {
        http.post('/api/v1/users/admin-verify-user', payload)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    adminQueryAccessReport (fromDate, endDate) {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/users/access-logs/summary?from_date=${fromDate}&end_date=${endDate}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    submitContact (payload) {
      return new Promise((resolve, reject) => {
        http.post('/api/v1/data/submit-contact', payload)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    updateUserEmail (payload) {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.patch('/api/v1/users/email', payload, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    updateUserPassword (payload) {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.patch('/api/v1/users/password', payload, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    updateUserProfile (payload) {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
        }
        http.patch('/api/v1/users/profile', payload, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    updateUserProfileImage (formData) {
      return new Promise((resolve, reject) => {
        const userIdentity = context.store.getters['auth/userIdentity']
        let headers = {}
        if (userIdentity) {
          headers = addAuthHeader(headers, userIdentity.access_token)
          headers['Content-Type'] = 'multipart/form-data'
        }
        http.post('/api/v1/users/profile/image', formData, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getCalendar (query) {
      return new Promise((resolve, reject) => {
        const params = Object.keys(query)
          .map(key => [key, query[key]].join('='))
          .join('&')
        http.get(`/api/v1/booking/local-calendar?${params}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getLocalCalendar (query) {
      return new Promise((resolve, reject) => {
        const params = Object.keys(query)
          .map(key => [key, query[key]].join('='))
          .join('&')
        http.get(`/api/v1/booking/local-calendar?${params}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getZoneList (zone) {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/booking/zones`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getHeroBannerList () {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/content/hero-banner`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getPopupList () {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/content/pin-banner`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getActivities (query) {
      const params = Object.keys(query)
        .map(key => [key, query[key]].join('='))
        .join('&')
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/content/activities?${params}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getEvents (query) {
      const params = Object.keys(query)
        .map(key => [key, query[key]].join('='))
        .join('&')
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/content/events?${params}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getActivity (id) {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/content/activities/${id}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getEvent (id) {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/content/events/${id}`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getOccupancyRate () {
      return new Promise((resolve, reject) => {
        http.get(`/api/v1/logs/occupancy`)
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    deleteMyAccount () {
      const userIdentity = context.store.getters['auth/userIdentity']
      let headers = {}
      if (userIdentity) {
        headers = addAuthHeader(headers, userIdentity.access_token)
      }
      return new Promise((resolve, reject) => {
        http.delete(`/api/v1/users`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getActivePrivileges () {
      return new Promise((resolve, reject) => {
        http.get('/api/v1/coop-privilege/list?page=1&page_size=99999&orderby=id&dir=DESC&status=active')
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    },
    getPenaltyHistoryList (id) {
      const adminIdentity = context.store.getters['auth/adminIdentity']
      let headers = {}
      if (adminIdentity) {
        headers = addAuthHeader(headers, adminIdentity.access_token)
      }
      return new Promise((resolve, reject) => {
        http.get(`/api/v2/member/penalty?identity_id=${id}`, { headers })
          .then((res) => {
            resolve(parseResponse(res))
          }).catch((e) => {
            reject(parseErrorResponse(e))
          })
      })
    }
  }
}
